import React from 'react';
import { skills } from '../data/profile';
import { Section } from './ui';

const Skills: React.FC = () => (
  <Section
    id="skills"
    index="04"
    eyebrow="Skills"
    title={
      <>
        The <em className="text-accent">toolbox</em>.
      </>
    }
  >
    <dl className="border-t border-ink-700">
      {skills.map((group) => (
        <div
          key={group.label}
          className="reveal grid gap-3 border-b border-ink-700 py-6 sm:grid-cols-[200px_1fr] sm:items-baseline sm:gap-8"
        >
          <dt className="font-mono text-xs uppercase tracking-wider text-fg-faint">{group.label}</dt>
          <dd className="flex flex-wrap gap-x-2 gap-y-2">
            {group.items.map((item, i) => (
              <span
                key={item}
                className="chip-pop rounded-full border border-ink-700 px-3 py-1 text-sm text-fg hover:border-accent/50 hover:text-accent"
                style={{ '--i': i } as React.CSSProperties}
              >
                {item}
              </span>
            ))}
          </dd>
        </div>
      ))}
    </dl>
  </Section>
);

export default Skills;
